"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BatchEventModel = exports.PaginationEventModel = exports.SortingEventModel = void 0;
const react_1 = __importStar(require("react"));
const Table_1 = __importDefault(require("@material-ui/core/Table"));
const TableBody_1 = __importDefault(require("@material-ui/core/TableBody"));
const TableCell_1 = __importDefault(require("@material-ui/core/TableCell"));
const TableContainer_1 = __importDefault(require("@material-ui/core/TableContainer"));
const TableHead_1 = __importDefault(require("@material-ui/core/TableHead"));
const TablePagination_1 = __importDefault(require("@material-ui/core/TablePagination"));
const TableRow_1 = __importDefault(require("@material-ui/core/TableRow"));
const TableSortLabel_1 = __importDefault(require("@material-ui/core/TableSortLabel"));
const Toolbar_1 = __importDefault(require("@material-ui/core/Toolbar"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const Checkbox_1 = __importDefault(require("@material-ui/core/Checkbox"));
const IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
const Tooltip_1 = __importDefault(require("@material-ui/core/Tooltip"));
const Delete_1 = __importDefault(require("@material-ui/icons/Delete"));
class SortingEventModel {
    constructor(orderBy, order) {
        this.orderBy = orderBy;
        this.order = order;
    }
}
exports.SortingEventModel = SortingEventModel;
class PaginationEventModel {
    constructor(pageSize, pageNumber) {
        this.pageSize = pageSize;
        this.pageNumber = pageNumber;
    }
}
exports.PaginationEventModel = PaginationEventModel;
class BatchEventModel {
    constructor(pageSize, pageNumber) {
        this.pageSize = pageSize;
        this.pageNumber = pageNumber;
    }
}
exports.BatchEventModel = BatchEventModel;
function EnhancedTableHead(props) {
    const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort, headCells, actions, labelActionsText, checkbox, } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };
    return (react_1.default.createElement(TableHead_1.default, null,
        react_1.default.createElement(TableRow_1.default, null,
            checkbox && (react_1.default.createElement(TableCell_1.default, null,
                react_1.default.createElement(Checkbox_1.default, { indeterminate: numSelected > 0 && numSelected < rowCount, checked: rowCount > 0 && numSelected === rowCount, onChange: onSelectAllClick, inputProps: { 'aria-label': 'select all desserts' } }))),
            headCells.map((headCell) => {
                if (headCell.visibility !== false) {
                    if (headCell.sortable) {
                        return (react_1.default.createElement(TableCell_1.default, { key: headCell.id, align: 'left', sortDirection: orderBy === headCell.id ? order : false },
                            react_1.default.createElement(TableSortLabel_1.default, { active: orderBy === headCell.id, direction: orderBy === headCell.id ? order : 'asc', onClick: createSortHandler(headCell.id) }, headCell.label)));
                    }
                    else {
                        return (react_1.default.createElement(TableCell_1.default, { key: headCell.id, align: 'left' }, headCell.label));
                    }
                }
                else {
                    return null;
                }
            }),
            actions && actions.length && (react_1.default.createElement(TableCell_1.default, { align: 'right' }, labelActionsText ? labelActionsText : 'Actions')))));
}
const Grid = react_1.memo((props) => {
    var _a, _b;
    const { dataSource, actions, bacthField, sortingEvent, paginationEvent, batchValueEvent, actionEvent, orderOption, orderByOption, headCells, pageSizeOptions, labelDisplayedRows, labelRowsPerPage, labelActionsText, checkbox, batchDelete, toolbar, } = props;
    const EnhancedTableToolbar = (props) => {
        const { numSelected } = props;
        return (react_1.default.createElement(Toolbar_1.default, null,
            numSelected.length > 0 && (react_1.default.createElement(Typography_1.default, { color: "inherit", variant: "subtitle1", component: "div" },
                numSelected.length,
                " selected")),
            numSelected.length > 0 && (react_1.default.createElement(Tooltip_1.default, { title: "Delete" },
                react_1.default.createElement(IconButton_1.default, { onClick: () => {
                        batchDelete && batchDelete(selected);
                        setSelected([]);
                        batchValueEvent && batchValueEvent([]);
                    }, "aria-label": "delete Batch" },
                    react_1.default.createElement(Delete_1.default, null))))));
    };
    const initialState = {
        items: [],
        pageIndex: 0,
        pageSize: 0,
        totalCount: 0,
        totalPages: 0,
    };
    const [state, setState] = react_1.useState(initialState);
    const [order, setOrder] = react_1.useState(orderOption);
    const [orderBy, setOrderBy] = react_1.useState(orderByOption);
    const [selected, setSelected] = react_1.useState([]);
    const [offset, setOffset] = react_1.useState(0);
    const [take, setTake] = react_1.useState(pageSizeOptions ? pageSizeOptions[0] : 5);
    react_1.useEffect(() => {
        setState((prevState) => (Object.assign(Object.assign({}, prevState), dataSource)));
    }, [dataSource]);
    const handleClickBatch = (field) => {
        const selectedIndex = selected.indexOf(field);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, field);
        }
        else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        }
        else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        }
        else if (selectedIndex > 0) {
            newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
        }
        setSelected(newSelected);
        batchValueEvent && batchValueEvent(newSelected);
    };
    const handleChangePage = (event, newPage) => {
        if (checkbox) {
            setSelected([]);
        }
        setOffset(newPage);
        const paging = new PaginationEventModel(take, newPage);
        paginationEvent(paging);
    };
    const handleChangeRowsPerPage = (event) => {
        setTake(event.target.value);
        setOffset(0);
        const paging = new PaginationEventModel(parseInt(event.target.value), 0);
        paginationEvent(paging);
    };
    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
        const x = new SortingEventModel(property, isAsc);
        sortingEvent(x);
    };
    const isSelected = (field) => {
        return selected.indexOf(field) !== -1;
    };
    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = state.items.map((n) => n[bacthField]);
            setSelected(newSelecteds);
            batchValueEvent && batchValueEvent(newSelecteds);
            return;
        }
        setSelected([]);
        batchValueEvent && batchValueEvent([]);
    };
    const actionHandleOnClick = (row, i) => {
        actionEvent && actionEvent(row, i);
    };
    const emptyRows = take - Math.min(take, ((_a = state === null || state === void 0 ? void 0 : state.items) === null || _a === void 0 ? void 0 : _a.length) - offset * take);
    return (react_1.default.createElement("div", { className: "row" },
        toolbar && (react_1.default.createElement("div", { className: "col-sm-12 text-right" },
            react_1.default.createElement("div", { className: "batchItems" },
                react_1.default.createElement(EnhancedTableToolbar, { numSelected: selected })))),
        react_1.default.createElement("div", { className: "col-sm-12" },
            react_1.default.createElement(TableContainer_1.default, null,
                react_1.default.createElement(Table_1.default, { "aria-labelledby": "tableTitle", "aria-label": "enhanced table" },
                    react_1.default.createElement(EnhancedTableHead, { numSelected: selected.length, order: order, "aria-label": "filter list", orderBy: orderBy, onSelectAllClick: handleSelectAllClick, onRequestSort: handleRequestSort, rowCount: state.items.length, headCells: headCells, actions: actions, labelActionsText: labelActionsText, checkbox: checkbox }),
                    react_1.default.createElement(TableBody_1.default, null, (_b = state === null || state === void 0 ? void 0 : state.items) === null || _b === void 0 ? void 0 :
                        _b.map((row, index) => {
                            const isItemSelected = isSelected(row[bacthField]);
                            const labelId = `enhanced-table-checkbox-${index}`;
                            return (react_1.default.createElement(TableRow_1.default, { hover: true, role: "checkbox", "aria-checked": isItemSelected, key: row.username, selected: isItemSelected },
                                checkbox && (react_1.default.createElement(TableCell_1.default, null,
                                    react_1.default.createElement(Checkbox_1.default, { onClick: (event) => handleClickBatch(row[bacthField]), checked: isItemSelected, inputProps: { 'aria-labelledby': labelId } }))),
                                headCells.map((headcell, i) => {
                                    return headcell.visibility === false ? null : (react_1.default.createElement(TableCell_1.default, { component: "th", id: labelId, key: i }, row[headcell === null || headcell === void 0 ? void 0 : headcell.id]));
                                }),
                                actions && actions.length && (react_1.default.createElement(TableCell_1.default, { align: "right" }, actions === null || actions === void 0 ? void 0 : actions.map((val, i) => {
                                    const visibility = row[val === null || val === void 0 ? void 0 : val.visibilityBy];
                                    return visibility === 'false' ? null : (react_1.default.createElement(Tooltip_1.default, { title: val === null || val === void 0 ? void 0 : val.tooltip, key: i },
                                        react_1.default.createElement(IconButton_1.default, { onClick: (event) => actionHandleOnClick(row, i) },
                                            react_1.default.createElement("i", { className: val === null || val === void 0 ? void 0 : val.icon }))));
                                })))));
                        }),
                        emptyRows > 0 && (react_1.default.createElement(TableRow_1.default, null,
                            react_1.default.createElement(TableCell_1.default, { colSpan: 6 })))))),
            react_1.default.createElement(TablePagination_1.default, { labelDisplayedRows: labelDisplayedRows
                    ? labelDisplayedRows
                    : ({ from, to, count }) => `${from}-${to} of ${count !== -1 ? count : `more than ${to}`}`, labelRowsPerPage: labelRowsPerPage ? labelRowsPerPage : 'Rows per page:', rowsPerPageOptions: pageSizeOptions, component: "div", count: state.totalCount, rowsPerPage: take, page: offset, onChangePage: handleChangePage, onChangeRowsPerPage: handleChangeRowsPerPage }))));
});
Grid.displayName = 'Grid';
exports.default = Grid;
